import { roundAtDecimals } from 'common/Utils/NumberUtilities'
import { getMeasure } from 'common/Utils/StringUtilities'
import React from 'react'

/**
 * @param {Object}                                               args
 * @param {string}                                               args.partName
 * @param {number}                                               args.partId
 * @param {{ x: number, y: number, z: number, measure: string }} args.size
 * @param {{ value: number, measure: string }}                   args.weight
 */
export const PartInfoCard = ({ partName, partId, size, weight }) => {

	const DEFAULT_WEIGHT_MEASURE = 'g'
	const DEFAULT_SIZE_MEASURE = 'mm'

	if (!partId || !size || !weight) {
		return <></>
	} else {
		return (
			<div style={{
				position: 'absolute',
				top: 15,
				left: 15,
				backgroundColor: 'white',
				borderRadius: 6,
				boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
				border: '1px solid #e5e7eb',
				padding: 8,
				zIndex: 20,
				display: 'flex',
				flexDirection: 'column',
				gap: 6,
			}}>
				<div className="d-flex flex-column p-2">

					{/* PART NAME */}
					<h4>{partName}</h4>

					<div className='d-flex gap-3'>

						{/* SIZE */}
						<div>{size &&
						size.x &&
						size.y &&
						size.z &&
						`${roundAtDecimals(size.x, 1)} x ${roundAtDecimals(size.y, 1)} x ${roundAtDecimals(size.z, 1)} ${size.measure ?? DEFAULT_SIZE_MEASURE}`}{' '}
						</div>

						{/* WEIGHT */}
						<div>{weight && getMeasure(weight.value ? weight.value : weight, weight.measure ?? DEFAULT_WEIGHT_MEASURE)}</div>

					</div>

				</div>
			</div>
		)
	}
}
